<template>
    <div>
        <div v-if="cartItem" class="d-flex justify-space-between align-center">
            <div class="d-flex bundle-item" :class="unavailable ? 'bundle-item-disabled':''">
                <div>
                    <div style="cursor: pointer" @click="goToBundle(cartItem)" class="py-2 pr-2">
                        <v-img :src="cartItem.imgUrl" max-width="100"></v-img>
                    </div>
                </div>
                <div class="bundle-item-description">
                    <div style="cursor: pointer" @click="goToBundle(cartItem)">
                        <p class="mb-0">{{ cartItem.campaignName }}</p>
                    </div>
                    <div style="font-size: 12px; color: #e46574; width: 80px">
                        <span v-if="onlyOneBundleLeft(cartItem)">(Kun 1 igjen)</span>
                    </div>
                    <div class="d-flex align-center" v-if="!unavailable">
                        <v-icon size="40" :disabled="$wait.is(`loading clickAndCollect updateCartItemQuantity ${cartItem.id}`) || cartItem.quantity == 1"
                            color="primary"
                            @click="updateBundleQuantity(cartItem, $event, 'decrease')"> fxt-minus-circle </v-icon>
                        <div class="px-3 text-h5">{{ cartItem.quantity }}</div>
                        <v-icon size="40" :disabled="$wait.is(`loading clickAndCollect updateCartItemQuantity ${cartItem.id}`) || cartItem.quantity == onlineStock"
                            color="primary"
                            @click="updateBundleQuantity(cartItem, $event, 'increase')"> fxt-plus-circle </v-icon>
                    </div>
                    <div v-else>
                        Produktet er ikke tilgjengelig lenger
                    </div>
                </div>
            </div>
            <div class="d-flex align-center">
                <div>
                    <v-col class="hidden-xs-only text-right d-flex flex-column"
                        style="white-space: nowrap; justify-content: center" v-if="!unavailable">
                        <span :style="{
                            'font-size': cartItem.totalValue > cartItem.campaignValue ? '14px' : '16px',
                            'text-decoration': cartItem.totalValue > cartItem.campaignValue ? 'line-through' : '',
                            'font-weight': cartItem.totalValue > cartItem.campaignValue ? 'normal' : '',
                        }">kr {{ cartItem.totalValue * cartItem.quantity | currency(2, 2) }}</span>
                        <span style="color: red; font-size: 16px" v-if="cartItem.totalValue * cartItem.quantity > cartItem.campaignValue * cartItem.quantity">
                            kr {{ cartItem.campaignValue * cartItem.quantity | currency(2, 2) }}</span>
                    </v-col>
                </div>
                <div>
                    <v-col class="align-self-center text-center px-3" cols="1" v-show="inCart">
                        <v-icon color="primary" @click="removeBundleFromCart(cartItem)" :disabled="$wait.is(`loading clickAndCollect fetchDiscounts`)">fxt-trash</v-icon>
                    </v-col>
                </div>
            </div>
        </div>
        <hr v-if="!inCart" class="mt-4"
			style="border-image: linear-gradient(90deg, var(--v-primary-base) 0%, var(--v-primary-base) 51.04%, var(--v-primary-base) 100%) 1;">
		<div v-if="!inCart" class="d-flex justify-space-between align-center my-2" :class="inCart ? 'pr-12' : ''">
			<p class="mb-0 total-price">Totalt kroner</p>
			<div>
				<v-col class="text-right d-flex flex-column" style="white-space: nowrap; justify-content: center">
					<span :style="{
						'font-size': '16px',
						'text-decoration': '',
						'font-weight': '',
					}">kr {{ cartItem.campaignValue * cartItem.quantity | currency(2, 2) }}</span>

				</v-col>
			</div>
		</div>
    </div>
</template>
<script>
import webshopMixins from '@/components/webshop/cart/webshop.mixins';
export default {
    mixins: [webshopMixins],
    props: {
        cartItem: Object,
        inCart: Boolean,
        unavailable: Boolean
    },
    data() {
        return {
        };
    },
    computed: {
        onlineStock(){
            var cartItemStock = this.cartItem.subscriptionsList;
            var activeSites = this.salons.map(s => s.siteId) || []
            var onlineStocks = cartItemStock.filter(x => activeSites.includes(x.siteId))?.map(x => x.availableAmount)
            var onlineStock = onlineStocks.length ? onlineStocks.reduce((a, b) => a + b) : 0
            if(onlineStock == 0){
                return this.cartItem.maxPerCustomer
            }
            return onlineStock
        }
    },
    created(){
    }
};
</script>

<style scoped lang="scss">
.total-price {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;

    &__price {
        font-size: 22px;
        font-weight: 700;
        line-height: 20px;
    }
}
.bundle-item{
    &-disabled{
        opacity: 0.5
    }
    &-description{
        align-self: center;
    }
}
</style>